/* eslint-disable parog-web/no-glint-expect-error-directive */
import DiagnosticFields from '../hemato-cancer/diagnostic-fields';

<template>
  {{! @glint-expect-error }}
  <DiagnosticFields @form={{@form}} @patient={{@patient}} />
</template>
